export default __webpack_public_path__ + "static/media/ActualSpeed.42f38260.jpg";